import {createAsyncThunk} from "@reduxjs/toolkit";
import i18n from "../../config/i18n";
import QuestionService, {IQuestionCreateRequest} from "../../api/questionService";
import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import {SliceNames} from "../constants";

export const getQuestions =
    createAsyncThunk(`${SliceNames.QUESTION}/getQuestions`,
        async (_, thunkAPI) => {
            try {
                const res = await QuestionService.fetchQuestionsAdmin()
                return res.data
            } catch (e: any) {
                toastError(i18n.t('question_list_error'))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const createQuestion =
    createAsyncThunk(`${SliceNames.QUESTION}/createQuestion`,
        async (req: {
            question: IQuestionCreateRequest,
            handleCloseDialog: () => void
        }, thunkAPI) => {
            try {
                const res = await QuestionService.createQuestion(req.question)
                req.handleCloseDialog()
                toastSuccess(i18n.t('question_create_success'))
                return res.data
            } catch (e: any) {
                toastError(i18n.t('question_create_error'))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const updateQuestion =
    createAsyncThunk(`${SliceNames.QUESTION}/updateQuestion`,
        async (req: {
            questionId: string,
            question: IQuestionCreateRequest,
            handleCloseDialog: () => void
        }, thunkAPI) => {
            try {
                const res = await QuestionService.updateQuestion(req.questionId, req.question)
                req.handleCloseDialog()
                toastSuccess(i18n.t('question_update_success'))
                return res.data
            } catch (e: any) {
                toastError(i18n.t('question_update_error'))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const deleteQuestion =
    createAsyncThunk(`${SliceNames.QUESTION}/deleteQuestion`,
        async (req: {
            questionId: string,
            handleCloseDialog: () => void
        }, thunkAPI) => {
            try {
                await QuestionService.deleteQuestion(req.questionId)
                req.handleCloseDialog()
                toastSuccess(i18n.t('question_delete_success'))
                return req.questionId
            } catch (e: any) {
                toastError(i18n.t('question_delete_error'))
                return thunkAPI.rejectWithValue(e)
            }
        })
